import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import * as Colors from 'material-ui/styles/colors';

let instance;

export const styles = {
  dialogBody: {
    padding: 0,
    fontSize: 16,
    color: Colors.grey600,
    width: 870,
    maxWidth: 870,
  },
  dialogContent: {
    width: 870,
    maxWidth: 870,
  },
  dialogHeader: {
    fontSize: 24,
    backgroundColor: Colors.red900,
    color: 'white',
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  dialogFooter: {
    width: '100%',
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  infoBoxIcon: {
    fontSize: 30,
    marginLeft: 15,
    marginRight: 20,
  },
  reportErrorButton: {
    margin: 20
  },
  reportErrorButtonLabel: {
    color: 'black'
  },
  actionButton: {
    margin: 20,
    color: Colors.red900
  },
  errorMessageContainer: {
    margin: 20
  },
  closeIcon: {
    color: 'white'
  }
};

export default class AreYouSureDialog extends Component {
  constructor() {
    super();
    if (!instance) {
      instance = this;
    }
    this.state = {};
  }

  static areYouSure(props) {
    const {setOpen} = instance.props;
    instance.setState(props);
    setOpen(true);
  }

  handleCancel = () => {
    const {setOpen} = this.props;
    setOpen(false);
  };

  handleOk = () => {
    const {setOpen} = this.props;
    const {action} = this.state;
    action();
    setOpen(false);
  };

  render() {
    const {title, message, cancelButtonLabel, actionButtonLabel} = this.state;
    return (
      <Dialog
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}
        open={this.props.open}
      >
        <div style={styles.dialogHeader}>
          <FontIcon style={styles.infoBoxIcon} color={'white'} className="material-icons">error</FontIcon>
          {title}
          <span style={{flexGrow: 1}}/>
          <IconButton
            onClick={this.handleCancel}
            iconStyle={styles.closeIcon}
          >
            <FontIcon className="material-icons">close</FontIcon>
          </IconButton>
        </div>
        <div style={styles.errorMessageContainer}>
          {message}
        </div>
        <div
          style={styles.dialogFooter}>
          {
            cancelButtonLabel &&
            <FlatButton
              style={styles.reportErrorButton}
              labelStyle={styles.reportErrorButtonLabel}
              label={cancelButtonLabel}
              onClick={this.handleCancel}
            />
          }
          {
            actionButtonLabel &&
            <FlatButton
              primary
              style={styles.actionButton}
              label={actionButtonLabel}
              onClick={this.handleOk}
            />
          }
        </div>
      </Dialog>
    );
  }
}

AreYouSureDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  errorTitle: PropTypes.string,
  errorMessage: PropTypes.any,
};

AreYouSureDialog.defaultProps = {
  open: false,
};